'use strict';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";

import { register, start, templateConfig } from 'jails-js';
import * as validation from "./validation";
import * as ecommerce from "./ecommerce";

import * as formValidation from "./components/form-validation";
import * as sliderSwiper from "./components/slider-swiper";
import * as categoriesList from "./components/categories-list";
import * as brandsMenu from "./components/brands-menu";
import * as dialogModal from "./components/dialog-modal";
import * as comparisonSlider from "./components/comparison-slider";
import * as tabsComponent from "./components/tabs-component";
import * as heroSection from "./components/hero-section";
import * as menuBurger from "./components/menu-burger";
import * as selectChoices from "./components/select-choices";
import * as searchPanel from "./components/search-panel";
import * as searchBox from "./components/search-box";
import * as dropdownPanel from "./components/dropdown-panel";
import * as optionFieldset from "./components/option-fieldset";
import * as productForm from "./components/product-form";
import * as productConstructor from "./components/product-constructor";
import * as selectImg from "./components/select-img";
import * as formFilter from "./components/form-filter";
import * as formSelection from "./components/form-selection";
import * as cartButton from "./components/cart-button";
import * as cartMini from "./components/cart-mini";
import * as cartProduct from "./components/cart-product";
import * as fieldQuantity from "./components/field-quantity";
import * as socialShare from "./components/social-share";
import * as infiniteFeed from "./components/infinite-feed";
import * as quickOrder from "./components/quick-order";
import initReviewsAnchor from "./components/reviews-anchor";
import * as checkoutCart from "./components/checkout-cart";
import * as checkoutCoupon from "./components/checkout-coupon";
import * as checkoutForm from "./components/checkout-form";
import * as checkoutAddress from "./components/checkout-address";
import * as setField from "./components/set-field";
import * as shopPromotion from "./components/shop-promotion";
import * as googleReview from "./components/google-review";
import * as dialogReview from "./components/dialog-review";
import * as instagramCard from "./components/instagram-card";
import * as instagramPopup from "./components/instagram-popup";
import * as citySelector from "./components/city-selector";
import * as headerSticky from "./components/header-sticky";
import * as placeAutocomplete from "./components/place-autocomplete";
import * as intlTel from "./components/intl-tel";
import * as callbackForm from "./components/callback-form";
import * as callbackResponse from "./components/callback-response";

register('form-validation', formValidation, { ...validation });
register('slider-swiper', sliderSwiper);
register('categories-list', categoriesList);
register('brands-menu', brandsMenu);
register('dialog-modal', dialogModal);
register('comparison-slider', comparisonSlider);
register('tabs-component', tabsComponent);
register('hero-section', heroSection);
register('menu-burger', menuBurger);
register('select-choices', selectChoices);
register('search-panel', searchPanel);
register('search-box', searchBox);
register('dropdown-panel', dropdownPanel);
register('option-fieldset', optionFieldset);
register('product-form', productForm);
register('product-constructor', productConstructor);
register('select-img', selectImg)
register('form-filter', formFilter);
register('form-selection', formSelection);
register('cart-button', cartButton);
register('cart-mini', cartMini);
register('cart-product', cartProduct);
register('field-quantity', fieldQuantity);
register('social-share', socialShare);
register('blog-load-more', infiniteFeed);
register('infinite-feed', infiniteFeed);
register('quick-order', quickOrder);
register('intl-tel', intlTel);
register('checkout-cart', checkoutCart);
register('checkout-coupon', checkoutCoupon);
register('checkout-form', checkoutForm);
register('checkout-address', checkoutAddress);
register('set-field', setField);
register('shop-promotion', shopPromotion);
register('google-review', googleReview);
register('dialog-review', dialogReview);
register('instagram-card', instagramCard);
register('instagram-popup', instagramPopup);
register('city-selector', citySelector);
register('header-sticky', headerSticky);
register('place-autocomplete', placeAutocomplete);
register('callback-form', callbackForm);
register('callback-response', callbackResponse);

templateConfig({ tags: ["@{", "}"] });

start();

const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
document.documentElement.style.setProperty('--scroll-width', `${scrollbarWidth}px`);

document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-dialog]');
    if (!btn) return;

    const dialogId = btn.dataset.dialog;
    const dialog = document.getElementById(dialogId);
    dialog.showModal();
});

const burgerBtn = document.querySelector('.btn--burger');
burgerBtn.addEventListener('click', function() {
    const burgerMenu = document.querySelector('.menu--burger');
    burgerMenu.classList.toggle('menu--open');

    if (!burgerMenu.classList.contains('menu--open')) {
        burgerMenu.querySelector('search-box')?.resetSearch?.();
    }
});

Fancybox.bind("[data-fancybox]", {
    Carousel: {
        Thumbs: {
            type: "classic",
            Carousel: {
                center: (ref) => {
                    return (
                        !ref.isVertical() || ref.getTotalSlideDim() > ref.getViewportDim()
                    );
                },
                vertical: false,
                breakpoints: {
                    "(min-width: 771px)": {
                        vertical: true,
                    },
                },
            },
        },
    },
});

initReviewsAnchor();

ecommerce.default();

